import SBOPrint from './sboprint';

export const SBOPRINT_PRINTER_ALIAS = 'SboPrint';

export const sboPrint = new SBOPrint({ appName: import.meta.env.VITE_APP_NAME || 'Agua Potable' });
